import React from 'react';
import { Grid, Row, Col, Alert } from '../utils/bootstrap';
import { Helmet } from 'react-helmet';
import Map from './Map';
import MainImage from '../components/MainImage';

const style = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  input: {
    padding: 10,
    marginBottom: 10,
    backgroundColor: 'rgba(255,255,255,0.1)',
    boxShadow: 'none',
    outline: 'none',
    fontSize: '1em',
    textAlign: 'center',
    width: '100%',
  },
  contactTitle: {
    marginBottom: 0,
    color: 'white',
  },
  contactSubtitle: {
    fontStyle: 'italic',
    textTransform: 'none',
    fontWeight: 'normal',
    fontSize: '1.3rem',
    color: '#8e9196',
    marginTop: 0,
    paddingBottom: '1rem',
    textAlign: 'left',
  },
  contactSubtitle2: {
    textTransform: 'none',
    fontSize: '1.3rem',
    fontWeight: 'normal',
  },
};

class Input extends React.Component {
  render() {
    const { error, ...props } = this.props;
    return (
      <div>
        <input
          {...props}
          style={style.input}
          className={error ? 'error' : ''}
        />
        {error && <div className="error">{error}</div>}
      </div>
    )
  }
}

class Enquire extends React.Component {
  state = {
    company: '',
    person: '',
    address: '',
    phone: '',
    email: '',
    message: '',
    error: {},
    formMessage: '',
    formMessageType: '',
    loading: false,
  };

  componentDidMount(prevProps) {
    window.scrollTo(200, 0);
  }

  handleMapLoad(map) {
    this._mapComponent = map;
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Contact Us | Premium Capital Partners</title>
          <meta name="description" content="Contact Premium Capital Partners and explore how our innovative business financing products can help support your business needs." />
        </Helmet>
        <MainImage img="/contact.jpg">
          <h1>Business financing products</h1>
          <div />
          <h2>Contact Premium Capital Partners</h2>
          <div />
        </MainImage>
        <Grid>
          <Row>
            <Col xs={12}>
              <p style={{ margin: 0 }}>
                Premium Capital Partners is a business driven by a desire to build valuable
                partnerships. Whether you're a business looking to understand more about our
                pioneering business financing products, or a broker looking to explore the
                opportunities of insurance premium financing for your clients, our
                experienced team are happy to answer your queries.
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={5}>
              <h5 style={{textAlign: 'left'}}>
                You can get in touch with Premium Capital Partners using the following
                details:
              </h5>
              <h5 style={style.contactTitle}>
                Premium Capital Partners Sdn Bhd
                <div style={style.contactSubtitle2}>(Co No 611113-P)</div>
              </h5>
              <p>
                5.01, Level 5, Menara MBMR,<br />
                No.1, Jalan Syed Putra,<br />
                58000 Kuala Lumpur,<br />
                Malaysia.
              </p>
              <p>
                T: +603 27 100 123<br />
                F: +603 27 100 122
              </p>
              <p>
                License No. : WL4476/14/01-8/100820<br />
                Validity: 11/08/2018 – 10/08/2020
              </p>
              <Map
                containerElement={<div style={{ height: 250 }} />}
                mapElement={<div style={{ height: 250 }} />}
                markers={[{
                  position: {
                    lat: 3.121069,
                    lng: 101.679278,
                  },
                  key: `Premium Capital`,
                  defaultAnimation: 2,
                }]}
                onMapLoad={this.handleMapLoad.bind(this)}
              />
            </Col>
            <Col xs={12} md={7}>
              <h5 style={{ textTransform: 'uppercase' }}>Contact Us Today</h5>
              <form style={style.form} onSubmit={(e) => {
                e.preventDefault();
                const values = { ...this.state };
                const error = {};
                ['company', 'person', 'address', 'phone', 'email', 'message'].forEach(k => {
                  if (!values[k]) error[k] = 'Required';
                });
                if (values.phone && !/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(values.phone))
                  error.phone = 'Invalid phone number';
                // eslint-disable-next-line
                if (values.email && ! /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email))
                  error.email = 'Invalid email address';

                if (Object.values(error).length) return this.setState({ error, formMessage: '' });
                this.setState({ loading: true });

                const { company, person, address, phone, email, message} = this.state;
                return fetch('/mail.php', {
                  body: JSON.stringify({
                    company,
                    person,
                    address,
                    phone,
                    email,
                    message,
                  }),
                  method: 'POST',
                })
                .then(response => response.text().then(() => {
                  return this.setState({
                    company: '',
                    person: '',
                    address: '',
                    phone: '',
                    email: '',
                    message: '',
                    error: {},
                    formMessage: 'Thank you for getting in touch with us. We\'ll get' +
                    ' back to you within a few days',
                    formMessageType: response.status === 200 ? 'success' : 'error',
                    loading: false,
                  })
                }));
              }}>
                <Input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  style={style.input}
                  value={this.state.company}
                  onChange={(e) => this.setState({ company: e.target.value, formMessage: '', error: { ...this.state.error, company: null } })}
                  error={this.state.error.company}
                />
                <Input
                  type="text"
                  name="person"
                  placeholder="Contact Person"
                  style={style.input}
                  value={this.state.person}
                  onChange={(e) => this.setState({ person: e.target.value, formMessage: '', error: { ...this.state.error, person: null } })}
                  error={this.state.error.person}
                />
                <Input
                  type="text"
                  name="address"
                  placeholder="Address"
                  style={style.input}
                  value={this.state.address}
                  onChange={(e) => this.setState({ address: e.target.value, formMessage: '', error: { ...this.state.error, address: null } })}
                  error={this.state.error.address}
                />
                <Input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  style={style.input}
                  value={this.state.phone}
                  onChange={(e) => this.setState({ phone: e.target.value, formMessage: '', error: { ...this.state.error, phone: null } })}
                  error={this.state.error.phone}
                />
                <Input
                  type="text"
                  name="email"
                  placeholder="Email"
                  style={style.input}
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value, formMessage: '', error: { ...this.state.error, email: null } })}
                  error={this.state.error.email}
                />
                <div>
                  <textarea
                    name="message"
                    cols="40"
                    rows="5"
                    placeholder="Message"
                    style={style.input}
                    value={this.state.message}
                    onChange={(e) => this.setState({ message: e.target.value, formMessage: '', error: { ...this.state.error, message: null } })}
                    className={this.state.error.message ? 'error' : ''}
                  />
                  {this.state.error.message && <div className="error">{this.state.error.message}</div>}
                </div>
                <input
                  type="submit"
                  value="Submit"
                  disabled={this.state.loading}
                />
                <Alert bsStyle={this.state.formMessageType} style={this.state.formMessage ? {
                  opacity: 1,
                  height: 'auto',
                  paddingTop: 15,
                  paddingBottom: 15,
                } : {}}>
                  {this.state.formMessage}
                </Alert>
              </form>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Enquire;



// WEBPACK FOOTER //
// ./src/screens/Enquire.js